/**
 * Selects the initial video encoder profile based on measured bandwidth.
 *
 * @param {*} bandwidthKbps - Measured bandwidth in kbps
 * @returns {{ profile: string|null, audioOnly: boolean }}
 */
export function selectInitialProfile(bandwidthKbps) {
  const bw = parseInt(bandwidthKbps, 10);
  if (isNaN(bw) || bw < 0) return { profile: '180p_1', audioOnly: false };
  if (bw >= 2000) return { profile: '360p_4', audioOnly: false };
  if (bw >= 1000) return { profile: '240p_1', audioOnly: false };
  if (bw >= 500) return { profile: '180p_1', audioOnly: false };
  return { profile: null, audioOnly: true };
}
